import { getAction, postAction, postTag } from '@/api/manage';
import Vue from 'vue';
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types';
import { axios } from '@/utils/request';

//角色管理
const addRole = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/role/add', params);
const editRole = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/role/edit', params);
const checkRoleCode = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/role/checkRoleCode', params);
const queryall = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/role/queryall', params);
// 国君字典
const allType = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/dict/getDictItems/investType',
    params
  );

//用户管理

const getCorpShortNameFromSysDict = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/getCorpShortNameFromSysDict',
    params
  );
const addUser = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/add', params);
const editUser = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/edit', params);
const queryUserRole = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/queryUserRole', params);
const getUserList = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/list', params);
const frozenBatch = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/frozenBatch', params);
//验证用户是否存在
const checkOnlyUser = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/user/checkOnlyUser', params);
//改变密码
const changePassword = (params) =>
  postAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/user/changePassword',
    params
  );

//权限管理
const addPermission = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/add', params);
const editPermission = (params) =>
  postTag(process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/edit', params);
const getPermissionList = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/list', params);
const getSystemMenuList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/getSystemMenuList',
    params
  );
const getSystemSubmenu = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/getSystemSubmenu',
    params
  );
const getSystemSubmenuBatch = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/getSystemSubmenuBatch',
    params
  );

const queryTreeList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/queryTreeList',
    params
  );
const queryTreeListForRole = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/role/queryTreeList', params);
const queryListAsync = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/queryListAsync',
    params
  );
const queryRolePermission = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/queryRolePermission',
    params
  );
const saveRolePermission = (params) =>
  postAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/saveRolePermission',
    params
  );
const saveRoleColumn = (params) =>
  postAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/roleColumnSet/saveRoleColumn',
    params
  );
const queryPermissionsByUser = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/getUserPermissionByToken',
    params
  );
const loadAllRoleIds = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/loadAllRoleIds',
    params
  );
const getPermissionRuleList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/getPermRuleListByPermId',
    params
  );
const queryPermissionRule = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/queryPermissionRule',
    params
  );

// 部门管理
const queryDepartTreeList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/queryTreeList',
    params
  );
const queryIdTree = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/queryIdTree',
    params
  );
const queryParentName = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/queryParentName',
    params
  );
const searchByKeywords = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/searchBy', params);
const deleteByDepartId = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/delete', params);

//二级部门管理
const queryDepartPermission = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/queryDepartPermission',
    params
  );
const saveDepartPermission = (params) =>
  postAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/permission/saveDepartPermission',
    params
  );
const queryTreeListForDeptRole = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM +
      '/sys/sysDepartPermission/queryTreeListForDeptRole',
    params
  );
const queryDeptRolePermission = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM +
      '/sys/sysDepartPermission/queryDeptRolePermission',
    params
  );
const saveDeptRolePermission = (params) =>
  postAction(
    process.env.VUE_APP_CMS_SYSTEM +
      '/sys/sysDepartPermission/saveDeptRolePermission',
    params
  );
const queryMyDepartTreeList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/sysDepart/queryMyDeptTreeList',
    params
  );

//日志管理
const deleteLog = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/log/delete', params);
const deleteLogList = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/log/deleteBatch', params);

//数据字典
const addDict = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/dict/add', params);
const editDict = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/dict/edit', params);
const treeList = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/dict/treeList', params);
const addDictItem = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/dictItem/add', params);
const editDictItem = (params) =>
  postAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/dictItem/edit', params);

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/${code}`,
    params
  );
//从缓存中获取字典配置
function getDictItemsFromCache(dictCode) {
  if (
    Vue.ls.get(UI_CACHE_DB_DICT_DATA) &&
    Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]
  ) {
    let dictItems = Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode];
    // console.log("-----------getDictItemsFromCache----------dictCode=" + dictCode + "---- dictItems=", dictItems)
    return dictItems;
  }
}

//系统通告
const doReleaseData = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/annountCement/doReleaseData',
    params
  );
const doReovkeData = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/annountCement/doReovkeData',
    params
  );
//获取系统访问量
const getLoginfo = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/loginfo', params);
const getVisitInfo = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/visitInfo', params);

// 根据部门主键查询用户信息
const queryUserByDepId = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/user/queryUserByDepId',
    params
  );
// 重复校验
const duplicateCheck = (params) =>
  getAction(process.env.VUE_APP_CMS_SYSTEM + '/sys/duplicate/check', params);
// 加载分类字典
const loadCategoryData = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/category/loadAllData',
    params
  );
const checkRuleByCode = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM + '/sys/checkRule/checkByCode',
    params
  );
//我的通告
const getUserNoticeInfo = (params) =>
  getAction(
    process.env.VUE_APP_CMS_SYSTEM +
      '/sys/sysAnnouncementSend/getMyAnnouncementSend',
    params
  );

//企业微信模块
const editList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/application/getByAgent',
    params
  );
const editSubmit = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/application/edit',
    params
  );
const deleteApplication = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/application/delete',
    params
  );
const createApplication = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/application/create',
    params
  );
const getGroupmsgSendResult = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK +
      '/wechatwork/wechatMsg/getGroupmsgSendResult',
    params
  );
const mediaList = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/chatdata/conversation/mediaList',
    params
  );

//课程中心模块
const courseList = (params) =>
  getAction(process.env.VUE_APP_CMS_COURSE + '/course/findCourse', params);
const updateCourseTime = (params) =>
  postAction(
    process.env.VUE_APP_CMS_COURSE + '/course/updateCourseTime',
    params
  );
const addCourse = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/courseAdd',
    params
  );
const courseGroupList = (params) =>
  getAction(process.env.VUE_APP_CMS_COURSE + '/group/selectCourseChat', params);
const courseArrangement = (params) =>
  getAction(
    process.env.VUE_APP_CMS_COURSE + '/course/selectCourseArrangement',
    params
  );
const getCourse = (params) =>
  getAction(
    process.env.VUE_APP_CMS_COURSE + '/class/getClassByGroupId',
    params
  );
const coursePackList = (params) =>
  getAction(process.env.VUE_APP_CMS_COURSE + '/course/findCoursePack', params);
const calculateCourseTime = (params) =>
  postAction(
    process.env.VUE_APP_CMS_COURSE + '/class/calculateCourseTime',
    params
  );
const courseTeacherList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_COURSE + '/group/getGroupMemberBychatId',
    params
  );
const getListByClassId = (params) =>
  getAction(process.env.VUE_APP_CMS_COURSE + '/class/getListByClassId', params);
const getStudentDetailsList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_COURSE + '/class/getStudentDetailsList',
    params
  );

//素材审核

const getExamineDetail = (params) =>
  getAction(
    process.env.VUE_APP_CMS_EXAMINE + '/wechatwork/examine/queryExamineDetail',
    params
  );
const getExamineList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_EXAMINE + '/wechatwork/examine/getExamineList',
    params
  );
const changeExamine = (params) =>
  postAction(
    process.env.VUE_APP_CMS_EXAMINE + '/wechatwork/examine/examineResult',
    params
  );

const querySpeechcraftType = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/querySpeechcraftType',
    params
  ); //查询话术分类
const querySpeechcraftCategory = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/querySpeechcraftCategory',
    params
  ); //查询话术类型
const querySpeechcraftInfoById = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/querySpeechcraftInfoById',
    params
  ); //查询话术详情
const addSpeechcraftCategory = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/addSpeechcraftCategory',
    params
  ); //新增话术分类
const addSpeechcraft = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ + '/speechcraft/addSpeechcraft',
    params
  ); //新增话术
const changeSpeechcraftStatus = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/changeSpeechcraftStatus',
    params
  ); //新增话术
// speechcraft/changeSpeechcraftStatus                                                                              // /wechatwork-users-biz/speechcraft/addSpeechcraft

//微信客户
const getLabelAll = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/getEnterpriseTags',
    params
  );
const addLabel = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/addEnterpriseTags',
    params
  );
const removeLabel = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/removeEnterpriseTags',
    params
  );
const emptyLabel = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/emptyEnterpriseTags',
    params
  );
const editByUser = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER + '/wechatwork/client/editByUser',
    params
  );
const getContactByCus = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/getContactByCus',
    params
  );

//客户群聊
const transfer = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/transfer',
    params
  );
const getCusAll = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/getFollowUserList',
    params
  );
//群详情
const getChatDetail = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORKAPI +
      '/wechatworkapi/cusGroupChat/getGroupChatInfoList',
    params
  );
const getActRecordByChatId = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATWORKAPI +
      '/wechatworkapi/cusGroupChat/getActRecordByChatId',
    params
  );
const getDetailDataList = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORKAPI +
      '/wechatworkapi/cusGroupChat/countByGroupChatList',
    params
  );
const getGroupChatDataList = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORKAPI +
      '/wechatworkapi/cusGroupChat/getGroupChatDataList',
    params
  );
const countByGroupChatListToExcel = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORKAPI +
      '/wechatworkapi/cusGroupChat/countByGroupChatListToExcel',
    params
  );
const selectSpeechcraftMessage = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/selectSpeechcraftMessage',
    params
  );
const addSpeechcraftMessage = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/bindGroupSpeechcraftToGroupChat',
    params
  );
const delSpeechcraftMessage = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/unbindAppointGroupChatAndGroupSpeechcrafts',
    params
  );
const getAppointGroupChatBindGroupSpeechcrafts = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerGroupChat/getAppointGroupChatBindGroupSpeechcrafts',
    params
  );

//咨询管理

const addZx = (params) =>
  postTag(process.env.VUE_APP_CMS_COURSE + '/zx/addZx', params);
const updateZx = (params) =>
  postTag(process.env.VUE_APP_CMS_COURSE + '/zx/updateZx', params);

//客服模块
const editCusList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/getByUserId',
    params
  );
const editCusSubmit = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/editByUserId',
    params
  );
const departmentList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/getEditByUserId',
    params
  );
const createCusSubmit = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/createMember',
    params
  );
const deleteCus = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/deleteMember',
    params
  );
const deleteBatchCus = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/customerService/deleteBatchMember',
    params
  );

//销售管理
const addMember = (params) =>
  postAction(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/market/addMember',
    params
  );
//客户标签
const addTagGroup = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/addTagGroup',
    params
  );
const editTag = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/editTag',
    params
  );
const deleteTag = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/deleteTag',
    params
  );
// 系统标签
const addSystemTag = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tagmanage/addTag',
    params
  );
const editSystemTag = (params) =>
  postTag(
    process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tagmanage/editTagById',
    params
  );

const queryByFundCode = (params) =>
  getAction(
    process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/all',
    params
  );
const queryFundCode = (params) =>
  getAction(
    process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/limit',
    params
  );

const queryByRateId = (params) =>
  getAction(
    process.env.VUE_APP_CMS_PRODUCT +
      '/admin/product/productsFundRateBracket/queryByRateId',
    params
  );
const publishBatch = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/contNotice/publishBatch',
    params
  );
const noticeAddBatch = (params) =>
  postAction(process.env.VUE_APP_CMS_CONTENT + '/contNotice/addBatch', params);

const setProductBatch = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/contNotice/setProductBatch',
    params
  );
const setColumnBatch = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/contNotice/setColumnBatch',
    params
  );
const setColumnDeleteBatch = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/content/notice/delBatch',
    params
  ); //批量删除
const setColumnsetTop = (params) =>
  postAction(process.env.VUE_APP_CMS_CONTENT + '/contNotice/setTop', params); //置顶
const querylistHis = (params) =>
  getAction(process.env.VUE_APP_CMS_CONTENT + '/contNoticeHis/listHis', params); //历史版本
const querylistPp = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/contNotice/listResult',
    params
  ); // 匹配结果
const setColumnpublish = (params) =>
  postAction(process.env.VUE_APP_CMS_CONTENT + '/contNotice/publish', params); //下架
// 预警管理
const addWarning = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CHATDATA + '/wechatwork/warning/add',
    params
  );
const editWarning = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CHATDATA + '/wechatwork/warning/edit',
    params
  );
const getMatchWarningKeyWordConversationList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CHATDATA +
      '/conversation/getMatchWarningKeyWordConversationList',
    params
  ); //历史版本

//问卷管理
const selectpaper = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/cont/questions/selectpaper',
    params
  );
const deletepaper = (params) =>
  postAction(
    process.env.VUE_APP_CMS_CONTENT + '/cont/questions/delete',
    params
  );
//根据mediaId获取url
const getFileIOByMediaId = (params) =>
  getAction(
    process.env.VUE_APP_CMS_GROUPCHAT +
      '/wechatwork/wechatMsg/getFileIOByMediaId',
    params
  ); //历史版本
//投资经理
const fundManager = (params) =>
  getAction(
    process.env.VUE_APP_CMS_PRODUCT + '/product/productsFundManager/list',
    params
  );
//发送消息
const baseNameList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CHATDATA +
      '/chatdata/propelling/getBaseInfoOfEnterpriseApplication',
    params
  );
const messageList = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CHATDATA +
      '/chatdata/propelling/queryEnterprisePropellingMessages',
    params
  );
const submitMessage = (params) =>
  postTag(
    process.env.VUE_APP_CMS_CHATDATA +
      '/chatdata/propelling/enterprisePropellingMessage ',
    params
  );
const messageDetail = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CHATDATA +
      '/chatdata/propelling/queryAppointEnterprisePropellingMessage',
    params
  );
const getCreatePopName = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATUSERSBIZ +
      '/speechcraft/getLoginUserAccountAndRealName',
    params
  );
//债券交易
const queryDepartment = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CONTENT + '/cont/person/queryDepartment',
    params
  );
const selectDepartment = (params) =>
  getAction(
    process.env.VUE_APP_CMS_CONTENT + '/cont/person/selectDepartment',
    params
  );
const getCrmCustomerInfo = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/queryCrmCustomerInfoByPhone',
    params
  );
const queryCrmCustomerDetail = (params) =>
  getAction(
    process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/queryCrmCustomerDetailByCrmCustomerId',
    params
  );
const bindCrmCustomer = (params) => {
  return axios({
    url:
      process.env.VUE_APP_CMS_WECHATCUSTOMER +
      '/wechatwork/client/wechatExternalUserBindPhoneAndCrmCustomerId',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//公告新增
const noticeAdd = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/notice/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//子产品新增
const addSubproduct = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fundInfo/addAssociation',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//公告修改
const noticeEdit = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/notice/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//复制产品添加
const displayAdd = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fundInfo/copy',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//短信查询
const shortMessageList = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_SMSBIZ + '/sms/find',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//产品基本信息查询
const productMessageList = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    data: params,
  });
};
//定投计划查询
const fixedInvestment=(params)=>{
  return axios({
    url: process.env.VUE_APP_CMS_TRADEBIZ + '/tdPlPlan/page',
    method: 'post',
    data: params,
  });
};
//定投历史查询
const fixedHistory=(params)=>{
  return axios({
    url: process.env.VUE_APP_CMS_TRADEBIZ + '/tdPlOrder/page',
    method: 'post',
    data: params,
  });
};
//绑定虚拟产品大类
const allVirtualProduct = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fundInfo/fundParent',
    method: 'post',
    data: params,
  });
};
//产品基本信息导出
const exportXlsUrl = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_PRODUCT + '/product/fundInfo/exportXls',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};
//客户列表查询接口
const customerList = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CUSTOMER + '/customer/list',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};
//客户列表删除接口
const customerDelete = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CUSTOMER + '/customer/del',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};

const Blacklist = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CUSTOMER + '/customer/blacklist',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};
// 添加黑名单接口
const addBlackListMessage = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CUSTOMER + '/customer/blacklist/add',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};
//文章添加
const articleAdd = (params) => {
  return axios({
    url: process.env.VUE_APP_CMS_CONTENT + '/content/article/save',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    method: 'post',
    data: params,
  });
};
//获取当前图片链接
const upload = (params) => {
  return axios({
    url: 'system-file-biz/minio/file',
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
    responseType: 'arraybuffer',
    method: 'post',
    data: params,
  });
};

const queryReviewedAll = (params) =>
  getAction(
    process.env.VUE_APP_CMS_PRODUCT + '/product/fund/list/reviewed/all',
    params
  );

export {
  queryFundCode,
  getCorpShortNameFromSysDict,
  upload,
  productMessageList,
  fixedInvestment,
  fixedHistory,
  customerDelete,
  customerList,
  Blacklist,
  addBlackListMessage,
  exportXlsUrl,
  allVirtualProduct,
  shortMessageList,
  addSubproduct,
  displayAdd,
  noticeEdit,
  noticeAdd,
  articleAdd,
  messageDetail,
  selectDepartment,
  queryDepartment,
  submitMessage,
  messageList,
  baseNameList,
  getContactByCus,
  fundManager,
  allType,
  getCusAll,
  transfer,
  editByUser,
  emptyLabel,
  addLabel,
  removeLabel,
  getLabelAll,
  deleteBatchCus,
  deleteCus,
  departmentList,
  createCusSubmit,
  editCusSubmit,
  editCusList,
  editList,
  editSubmit,
  deleteApplication,
  createApplication,
  deletepaper,
  addRole,
  editRole,
  checkRoleCode,
  addUser,
  editUser,
  queryUserRole,
  getUserList,
  queryall,
  frozenBatch,
  checkOnlyUser,
  changePassword,
  getPermissionList,
  addPermission,
  editPermission,
  queryTreeList,
  queryListAsync,
  queryRolePermission,
  saveRolePermission,
  saveRoleColumn,
  queryPermissionsByUser,
  loadAllRoleIds,
  getPermissionRuleList,
  queryPermissionRule,
  queryDepartTreeList,
  queryIdTree,
  queryParentName,
  searchByKeywords,
  deleteByDepartId,
  deleteLog,
  deleteLogList,
  addDict,
  editDict,
  treeList,
  addDictItem,
  editDictItem,
  doReleaseData,
  doReovkeData,
  getLoginfo,
  getVisitInfo,
  queryUserByDepId,
  duplicateCheck,
  queryTreeListForRole,
  getSystemMenuList,
  getSystemSubmenu,
  getSystemSubmenuBatch,
  loadCategoryData,
  checkRuleByCode,
  queryDepartPermission,
  saveDepartPermission,
  queryTreeListForDeptRole,
  queryDeptRolePermission,
  saveDeptRolePermission,
  queryMyDepartTreeList,
  getUserNoticeInfo,
  getDictItemsFromCache,
  addMember,
  addTagGroup,
  editTag,
  deleteTag,
  addSystemTag,
  editSystemTag,
  queryByFundCode,
  queryByRateId,
  publishBatch,
  noticeAddBatch,
  setProductBatch,
  setColumnBatch,
  addWarning,
  editWarning,
  setColumnDeleteBatch,
  setColumnsetTop,
  querylistHis,
  querylistPp,
  setColumnpublish,
  querySpeechcraftType,
  querySpeechcraftCategory,
  querySpeechcraftInfoById,
  addSpeechcraftCategory,
  addSpeechcraft,
  changeSpeechcraftStatus,
  selectpaper,
  courseList,
  updateCourseTime,
  addCourse,
  courseGroupList,
  courseArrangement,
  getCourse,
  getExamineDetail,
  getExamineList,
  changeExamine,
  coursePackList,
  calculateCourseTime,
  courseTeacherList,
  getListByClassId,
  getStudentDetailsList,
  getChatDetail,
  getActRecordByChatId,
  getDetailDataList,
  getGroupChatDataList,
  countByGroupChatListToExcel,
  selectSpeechcraftMessage,
  addSpeechcraftMessage,
  delSpeechcraftMessage,
  getAppointGroupChatBindGroupSpeechcrafts,
  addZx,
  updateZx,
  getFileIOByMediaId,
  getMatchWarningKeyWordConversationList,
  getCreatePopName,
  getCrmCustomerInfo,
  bindCrmCustomer,
  queryCrmCustomerDetail,
  queryReviewedAll,
};
